import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * X-Platform (frente #2 / captación-app): la web declara su plataforma en cada
 * request para que el backend segmente popups/banners/ad-tiles (web|app|both).
 * El cliente web siempre envía `web`. El header lo lee el backend con default
 * `web`, así que es idempotente y no rompe nada si faltara.
 */
export const platformInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const withPlatform = req.clone({
    headers: req.headers.set('X-Platform', 'web'),
  });
  return next(withPlatform);
};
